import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BlobToBase64Service from '../../services/idverification/BlobToBase64Service';
import mapStateToProps from '../../services/idverification/IdVerificationComponentService';
import styles from './idverification.scss';

class PureIdVerification extends React.PureComponent {
    static propTypes = {
        stepElement: PropTypes.element.isRequired,
    };

    componentWillUnmount() {
        BlobToBase64Service.releaseReader();
    }

    render() {
        const { stepElement } = this.props;

        return (
            <div className={styles.step}>
                {stepElement}
            </div>
        );
    }
}

const IdVerification = connect(mapStateToProps)(PureIdVerification);

export { PureIdVerification };
export default IdVerification;
